"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPaymentOwningUserType = exports.DefaultPaymentOwnerType = void 0;
var DefaultPaymentOwnerType;
(function (DefaultPaymentOwnerType) {
    /**
     * Represents a Broadleaf-managed cart.
     */
    DefaultPaymentOwnerType["BLC_CART"] = "BLC_CART";
    /**
     * Represents a Broadleaf-managed subscription.
     */
    DefaultPaymentOwnerType["BLC_SUBSCRIPTION"] = "BLC_SUBSCRIPTION";
})(DefaultPaymentOwnerType || (exports.DefaultPaymentOwnerType = DefaultPaymentOwnerType = {}));
/**
 * Default types of payments represented by a <<PaymentRequest>>.
 */
var DefaultPaymentOwningUserType;
(function (DefaultPaymentOwningUserType) {
    /**
     * Represents a Broadleaf-managed customer.
     */
    DefaultPaymentOwningUserType["BLC_CUSTOMER"] = "BLC_CUSTOMER";
    /**
     * Represents a Broadleaf-managed account.
     */
    DefaultPaymentOwningUserType["BLC_ACCOUNT"] = "BLC_ACCOUNT";
})(DefaultPaymentOwningUserType || (exports.DefaultPaymentOwningUserType = DefaultPaymentOwningUserType = {}));
//# sourceMappingURL=payment.js.map